import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { messageService } from '../message.service';

@Component({
  selector: 'app-login-ad-temp',
  templateUrl: './login-ad-temp.component.html',
  styleUrls: ['./login-ad-temp.component.scss']
})
export class LoginAdTempComponent implements OnInit {
  loading: boolean;
  orgDetail: any;


  constructor(private authService: MsalService, private appService: AppService, private router: Router, private dialog: MatDialog, private message: messageService) {

  }
  data1: { applicationUrl: string; };

  ngOnInit(): void {
    localStorage.clear();
    if (location.href == "http://localhost:4200/login/addd") {
      this.data1 = {
        applicationUrl: "https://predev.one-qms.com/login/astad"
      }
    } else {
      this.data1 = {
        applicationUrl: location.href,
      }
    }
    console.log(this.data1);
    this.loading = true;
    this.appService.orgDetails(this.data1).subscribe((data: any) => {

      this.orgDetail = data;
      if (data != null) {

        localStorage.setItem("adEnabled", data.adEnabled);
        localStorage.setItem("adredirecturl", location.pathname);
        localStorage.setItem("adapplicationUrl", this.data1.applicationUrl);

        if (data.adEnabled == "Y") {
          //  this.configureMsalInstance(data.clientId, data.talentId);

          this.router.navigate(['../logins']);

        } else {
          this.router.navigate(['/loginorg']);
        }
      } else {
        alert("Please contact system administrator")
      }


      function delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      this.message.setOrgId(this.orgDetail.orgId);
    });
  }
  configureMsalInstance(clientId: string, tenantId: string): void {
    // Reinitialize the MSAL instance with updated configuration
    this.authService.instance = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: location.origin + '/profile',
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    };

  }
}
